export const patientsFr = {
  "Consultations": "Consultations", 
  "Patients En cours": "Patients En cours", 
  "Patients Terminé": "Patients Terminé", 
  
  "DOSS.NO": "DOSS.NO",
  "WhatsApp": "WhatsApp",
  "Balance": "Balance",
  "Chercher par Doss.NO": "Chercher par Doss.NO",
  "Chercher par nom": "Chercher par nom",
  "Chercher par numero telephone": "Chercher par numero telephone",
  "Non Archivé": "Non Archivé",
  "Archivé": "Archivé",
  "Patients": "Patients",
  "Patients en commun": "Patients en commun",
  "Débiteur": "Débiteur",
  "Régulariser": "Régulariser",
  "Créancier": "Créancier",

  "Nom du patient": "Nom du patient",
  "Numero de telephone": "Numero de telephone",
  "Address du patient": "Address du patient",
  "Address": "Address",
  "Année de naissance": "Année de naissance",
  "Etat de Santé": "Etat de Santé",
  
  
  "Ajouter": "Ajouter",
  "Modifier": "Modifier",
  "Supprimer": "Supprimer",
  "Passer": "Passer",
  "Retourner": "Retourner",
  "Terminer": "Terminer",
  "Envoyer": "Envoyer",
  "Fermer": "Fermer",
  "Prise en charge": "Prise en charge",

  "Assuré": "Assuré",
  "Matricule Professionel": "Matricule Professionel",
  "Pourcentage couvré par la societé": "Pourcentage couvré par la societé",

  /** START DEVIS  */
  "Traitement": "Traitement",
  "Dents": "Dents",
  "Surface": "Surface",
  "NBS": "NBS",
  "Prix.U": "Prix.U",
  "Total": "Total",
  "Reduction": "Reduction",
  "Reste": "Reste",

  "Ajouter un traitment pour creer un devis": "Ajouter un traitment pour creer un devis",
  "Actions": "Actions",
  
  "Nom du traitement": "Nom du traitement",
  "Choisir les traitments du cabinet": "Choisir les traitements du cabinet",
  "Donner la reduction en pourcent": "Donner la reduction en pourcent",
  "Qty": "Qté",
  "Dents Pediatre": "Dents Pediatre",

  /** END DEVIS  */

  /** START Fiche  */
  
  "Date": "Date",
  "Actes": "Actes",
  "Montant": "Montant",
  "Facture": "Facture",
  "RDV": "RDV",
  
  /** END Fiche  */


  /** START INvoices */

  "global": "global",
  "cabinet": "cabinet",
  
  "Payé par l'Assurance": "Payé par l'Assurance",
  "Payé par le patient": "Payé par le patient",
  
  /** END INvoices */
  
  "Laboratoire": "Laboratoire",
  "Mode de paiement": "Mode de paiement",
  "Status": "Status",
  "Reste du devis": "Reste du devis",
  "Age": "Age",

  /** START Bar navigation of manage patient **/
  
  "Devis": "Devis",
  "Factures": "Factures",
  "Labo": "Labo",
  "Paiements": "Paiements",
  "Pay Assuré": "Pay Assuré",
  "Soins": "Soins",
  "Fiches": "Fiches",
  "Fiche": "Fiche",
  
  /** END Bar navigation of manage patient **/

  // Server Side 
  "Donner une reduction valide": "Donner une reduction valide",
  "Le traitement a ete fait vous ne pouvez plus le supprimer.": "Le traitement a ete fait vous ne pouvez plus le supprimer.",
  "la dernière facture n'est pas encore clôturé": "la dernière facture n'est pas encore clôturé",
  "La facture ne peut pas être supprimée car elle est déjà remplie": "La facture ne peut pas être supprimée car elle est déjà remplie",

  "Le doctor est obligatoire.": "Le doctor est obligatoire.",
  "Le nom du patient est obligatoire.": "Le nom du patient est obligatoire.",
  "Le telephone du patient est obligatoire.": "Le telephone du patient est obligatoire.",
  "Année de naissance du patient est obligatoire.": "Année de naissance du patient est obligatoire.",
  "Choisir societe d'assurance.": "Choisir societe d'assurance.",
  "Donner le matricule.": "Donner le matricule.",
  "Donner la prise en charge.": "Donner la prise en charge.",
  "Donner le pourcentage.": "Donner le pourcentage.",

  "Donner le montant": "Donner le montant",
  "Le patient est assuré par une societe que vous n'avez pas encore creer sa facture": "Le patient est assuré par une societe que vous n'avez pas encore creer sa facture",
  "Veuillez creer une facture pour cette societe d'assurance": "Veuillez creer une facture pour cette societe d'assurance",
  

}

